export class HeaderThemeChangedEvent extends CustomEvent<{
  transparent: boolean;
  instant: boolean;
}> {}
